
import { sendPost } from "../helpers";

const getDataChart = async (params, onSucces = () => { }, onError = () => { }) => {
  try {
    const res = await sendPost("/chart-data/static", params);
    if (res.status === 200) {
      if (res?.data.result === "failure") {
        onError(res?.data.reason)
      } else {
        if(res?.data?.data?.user_info){
          await localStorage.setItem('DATA_MEMBER_ADMIN', JSON.stringify(res.data.data.user_info));
        }
        onSucces(res?.data?.data);
      }
    }
  } catch (error) {
  }
}

const getDataLineChart = async (params, onResponse) => {
  try {
      const res = await sendPost("/chart-data/static-day", params);
      if (res.status === 200) {
          if(res.data){
              onResponse(res.data)
          }
      }
  } catch (error) {
      console.log(error);
  }
}

const getHealthChart = async (params, onResponse) => {
  try {
      const res = await sendPost("/cart-product/getHealthUrl", params);
      if (res.status === 200) {
          if(res.data){
              onResponse(res.data)
          }
      }
  } catch (error) {
      console.log(error);
  }
}

const getPrdInCart = async (params, onResponse) => {
  try {
      const res = await sendPost("/cart-product/getCartInfo", params);
      if (res.status === 200) {
          if(res.data){
              onResponse(res.data)
          }
      }
  } catch (error) {
      console.log(error);
  }
}

const addToCart = async (params, onResponse) => {
  try {
      const res = await sendPost("/cart-product/addCartItem", params);
      if (res.status === 200) {
          if(res.data){
              onResponse(res.data)
          }
      }else{
        onResponse(res.response)
      }
  } catch (error) {
    console.log(error);
    // onResponse(error)
  }
}

const getRadarAddToCard = async (params, onResponse) => {
  try {
      const res = await sendPost("/chart-data/static-cart", params);
      
      if (res.status === 200) {
          if(res.data){
              onResponse(res.data)
          }
      }
  } catch (err) {
      console.log(err);
  }
}

const chartService = { getDataChart, getDataLineChart, getHealthChart, getPrdInCart, addToCart, getRadarAddToCard };
export default chartService;